import { KeenSliderOptions } from 'keen-slider/react';

export const sharedSlidesOptions = {
  origin: 'center' as const,
  spacing: 24,
};

export const desktopDragOptions = {
  mode: 'free' as const,
  dragSpeed: 0.5,
};

export const sliderOptions = {
  loop: true,
  drag: true,
  slides: { ...sharedSlidesOptions, perView: 1.2, spacing: 12 },
  breakpoints: {
    '(min-width: 600px)': { ...desktopDragOptions, slides: { ...sharedSlidesOptions, perView: 2 } },
    '(min-width: 1024px)': { ...desktopDragOptions, slides: { ...sharedSlidesOptions, perView: 2.75 } },
    '(min-width: 1440px)': { ...desktopDragOptions, slides: { ...sharedSlidesOptions, perView: 3.5 } },
  },
} satisfies KeenSliderOptions;
